module.exports = __webpack_public_path__ + "img/valimail.e0a586e7.png";